import { createConnectQueryKey } from '@connectrpc/connect-query'
import {
  createSubmitterMaster,
  listSubmitterMasters,
} from '@ebalance/proto/bffuser/v1/occto_master_service-OcctoMasterService_connectquery'

import {
  type InvalidatingMutationResultFor,
  useInvalidatingMutation,
} from '~/hooks/useInvalidatingMutation'

/**
 * 計画提出者マスタ 新規登録 mutation hook。
 * onSuccess で list query を invalidate してテーブルを最新化する。
 */
export function useCreateSubmitterMaster(): InvalidatingMutationResultFor<
  typeof createSubmitterMaster
> {
  return useInvalidatingMutation(createSubmitterMaster, [
    createConnectQueryKey({
      schema: listSubmitterMasters,
      cardinality: 'finite',
    }),
  ])
}
